var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGround(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 12,
    viewBox: "0 0 16 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.52389 11.5549C3.51954 11.5549 3.51651 11.5506 3.51795 11.5465L7.60281 0.0041876C7.60372 0.00167821 7.60609 0 7.60875 0H11.9694C11.9721 0 11.9745 0.00169072 11.9754 0.00421573L15.9997 11.5465C16.0011 11.5506 15.998 11.5549 15.9937 11.5549H3.64664H3.52389ZM0.00629084 11.6C0.00190351 11.6 -0.00113392 11.5956 0.000405024 11.5915L3.04228 3.47051C3.0432 3.46804 3.04555 3.46642 3.04817 3.46642H5.69121C5.69558 3.46642 5.69862 3.47076 5.69711 3.47486L2.75571 11.5959C2.75481 11.5984 2.75244 11.6 2.7498 11.6H0.00629084Z",
    fill: "#CE8056"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGround);
export default __webpack_public_path__ + "static/media/ground.acfa6d39984595ab9b2246e72a25e82f.svg";
export { ForwardRef as ReactComponent };